import axios, { AxiosError } from 'axios';
import { aesEncrypt } from './aes';
import { FormData, InvoiceFormCreateRequiredFields } from './enum';
import { isNullOrEmpty } from '.';

export async function getInvoiceFormCheck(combinedIdAndPhone: string, t?: any) {
    console.log('called api api_taxreceipt_info')
    try {
        const data = isNullOrEmpty(combinedIdAndPhone) ? combinedIdAndPhone : encodeURIComponent(aesEncrypt(combinedIdAndPhone.toString()));
        console.log('getInvoiceFormCheck URL : ', `//${process.env.REACT_APP_API_DOMAIN}/api_taxreceipt_info/${data}`);
        const response = await axios.get(`//${process.env.REACT_APP_API_DOMAIN}/api_taxreceipt_info/${data}`);
        console.log(response.data);
        return response.data; // Return the response data
    } catch (error: any) {
        if (axios.isAxiosError(error)) {
            if (error?.response) {
                console.error('Server responded with an error', error?.response?.data);
                return error?.response?.data; // Return an error object
            } else if (error?.request) {
                console.error('No response received', error.request);
                return 'No response received'; // Return an error object
            }
        }
        console.error('Error', (error as any)?.message);
        return 'An unexpected error occurred'; // Return an error object
    }
}

export async function createInvoiceFormRecord(formData: FormData, t: any) {
    console.log('Creating invoice form record');

    let missingFields = [];

    // Check if required fields are provided
    for (const field of InvoiceFormCreateRequiredFields[formData.alignment]) {
        if (isNullOrEmpty(formData[field])) {
            missingFields.push(field);
        }
    }

    if (missingFields.length > 0) {
        return { missingFields };
    }

    try {
        const data = isNullOrEmpty(formData) ? formData : { encryptedData: encodeURIComponent(aesEncrypt(JSON.stringify(formData))) };
        console.log('data', data)
        // Send the POST request
        console.log('createInvoiceFormRecord URL : ', `//${process.env.REACT_APP_API_DOMAIN}/api_taxreceipt_add/${data.encryptedData}`, data)
        const response = await axios.post(`//${process.env.REACT_APP_API_DOMAIN}/api_taxreceipt_add/${data.encryptedData}`, data);
        console.log(response.data);
        return response.data; // Return the response data
    } catch (error: any) {
        if (axios.isAxiosError(error)) {
            if (error.response) {
                console.error('Server responded with an error', error.response.data);
                return error.response.data; // Return an error object
            } else if (error.request) {
                console.error('No response received', error.request);
                return {
                    Result: 'false',
                    error: 'No response received'
                }; // Return an error object
            }
        }
        console.error('Error', error?.message);
        return {
            Result: 'false',
            error: 'An unexpected error occurred'
        }; // Return an error object
    }
}